function handleizeTag(value) {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function isProductComingSoon(product) {
  if (!product?.tags?.length) return false;

  return product.tags.some((tag) => handleizeTag(tag) === 'coming-soon');
}

function cartHasComingSoonProducts() {
  if (document.querySelector('[data-cart-form][data-cart-has-coming-soon="true"]')) {
    return true;
  }

  return document.querySelector('[data-product-coming-soon="true"]') !== null;
}

function isComingSoonAddToCartTarget(button) {
  if (!button) return false;

  const productSection = button.closest('[data-section-type="product"]');
  if (productSection?.getAttribute('data-coming-soon') === 'true') {
    return true;
  }

  const quickAddHolder = button.closest('[data-quick-add-holder]');
  if (quickAddHolder?.getAttribute('data-coming-soon') === 'true') {
    return true;
  }

  const recommendationForm = button.closest('.cart_recommendation_product__form');
  if (recommendationForm?.getAttribute('data-coming-soon') === 'true') {
    return true;
  }

  return false;
}

function updateCheckoutButtons() {
  const hasComingSoon = cartHasComingSoonProducts();

  document.querySelectorAll('[data-cart-checkout-buttons]').forEach((wrapper) => {
    const fieldset = wrapper.querySelector('[data-cart-checkout-button]');
    const checkoutButton = fieldset?.querySelector('button[name="checkout"]');
    const error = wrapper.parentElement?.querySelector('[data-coming-soon-error-message]')
      || wrapper.querySelector('[data-coming-soon-error-message]');
    const termsCheckbox = document.querySelector('[data-cart-acceptance-checkbox]');
    const termsBlocking = termsCheckbox && !termsCheckbox.checked;

    if (hasComingSoon) {
      wrapper.classList.add('cart__buttons--disabled');
      fieldset?.setAttribute('disabled', 'disabled');
      checkoutButton?.setAttribute('disabled', 'disabled');
      error?.classList.add('is-expanded');
      return;
    }

    error?.classList.remove('is-expanded');

    if (!termsBlocking) {
      wrapper.classList.remove('cart__buttons--disabled');
      fieldset?.removeAttribute('disabled');
      checkoutButton?.removeAttribute('disabled');
    }
  });

  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    form.setAttribute('data-cart-has-coming-soon', hasComingSoon ? 'true' : 'false');
  });
}

function bindCartForms() {
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    if (form.dataset.comingSoonBound === 'true') return;
    form.dataset.comingSoonBound = 'true';

    form.addEventListener('submit', (event) => {
      if (!cartHasComingSoonProducts()) return;

      const submitter = event.submitter;
      if (submitter?.name === 'checkout') {
        event.preventDefault();
        updateCheckoutButtons();
      }
    });
  });
}

document.addEventListener(
  'theme:cart:add',
  (event) => {
    if (isComingSoonAddToCartTarget(event.detail?.button)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

function initComingSoonCartGuards() {
  bindCartForms();
  updateCheckoutButtons();
}

document.addEventListener('theme:cart:change', initComingSoonCartGuards);
document.addEventListener('theme:cart:drawer:update', initComingSoonCartGuards);
document.addEventListener('DOMContentLoaded', initComingSoonCartGuards);
